export default "__VITE_ASSET__BKoPI9Zy__"